import { render, staticRenderFns } from "./ModalEditCategory.vue?vue&type=template&id=adadd9c6&scoped=true"
import script from "./ModalEditCategory.vue?vue&type=script&lang=js"
export * from "./ModalEditCategory.vue?vue&type=script&lang=js"
import style0 from "./ModalEditCategory.vue?vue&type=style&index=0&id=adadd9c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adadd9c6",
  null
  
)

export default component.exports